module.exports = __webpack_public_path__ + "img/coderbot_wide1.7bb398ef.jpg";